import { AuthService } from '@skinsoft/auth';
import { Login } from '@skinsoft/auth-ui'
import { first, map } from 'rxjs/operators';
import { createRouter, createWebHistory, RouteRecordRaw, Router } from 'vue-router';
import { router as unifiedRouter } from '../../../reporter-launcher/src/router' // TODO better'

import { CommonRoutes, TrackingRoutes } from '@skinsoft/const';
import { ContainerDataStore, MovementDataStore, TaskDataStore } from '@skinsoft/entity';
import {
    ContainerFeaturedList,
    MovementFeaturedList,
    MovementHistory,
    TaskFeaturedList,
    TaskHistory,
} from '@skinsoft/entity-ui';

import { Dashboard } from './dashboard';
import { ActionMenuMovement } from './entity/component/action-menu/movement';
import { ActionMenuTask } from './entity/component/action-menu/task';
import { EntityList } from './entity/page/entity-list';
import { MovementPage } from './entity/page/movement-page';
import { TaskPage } from './entity/page/task';
import { ContainerPage } from './entity/page/container';
import { ActionMenuContainer } from './entity/component/action-menu/container';


declare var UNIFY_ROUTER: boolean;

const routes = [
    {
        component: Dashboard,
        name: TrackingRoutes.TRACKING_HOME,
        path: '/trackingHome',
    },
    {
        component: EntityList,
        name: TrackingRoutes.TASKS,
        path: '/tasks',
        props: {
            entityDataStore: TaskDataStore.getInstance(),
            entityFeaturedList: TaskFeaturedList,
            entityHistory: TaskHistory,
            targetRouteName: TrackingRoutes.TASK,
        },
    },
    {
        components: {
            actionMenu: ActionMenuMovement,
            default: EntityList,
        },
        name: TrackingRoutes.MOVEMENTS,
        path: '/movements',
        props: {
            actionMenu: {
                entityDataStore: MovementDataStore.getInstance(),
            },
            default: {
                entityDataStore: MovementDataStore.getInstance(),
                entityFeaturedList: MovementFeaturedList,
                entityHistory: MovementHistory,
                targetRouteName: TrackingRoutes.MOVEMENT,
            },
        },
    },
    {
        components: {
            actionMenu: ActionMenuContainer,
            default: EntityList
        },
        name: TrackingRoutes.CONTAINERS,
        path: '/containers',
        props: {
            actionMenu: {
                entityDataStore: ContainerDataStore.getInstance()
            },
            default: {
                entityDataStore: ContainerDataStore.getInstance(),
                entityFeaturedList: ContainerFeaturedList,
                targetRouteName: TrackingRoutes.CONTAINER
            }
        }
    },
    {
        components: {
            actionMenu: ActionMenuMovement,
            default: MovementPage,
        },
        name: TrackingRoutes.MOVEMENT,
        path: '/movements/:id',
        props: {
            actionMenu: {
                entityDataStore: MovementDataStore.getInstance(),
            },
        },
    },
    {
        components: {
            actionMenu: ActionMenuTask,
            default: TaskPage,
        },
        name: TrackingRoutes.TASK,
        path: '/tasks/:id',
        props: {
            actionMenu: {
                entityDataStore: TaskDataStore.getInstance(),
            },
        },
    },
    {
        components: {
            actionMenu: ActionMenuContainer,
            default: ContainerPage
        },
        props: {
            actionMenu: {
                entityDataStore: ContainerDataStore.getInstance()
            },
        },
        name: TrackingRoutes.CONTAINER,
        path: '/containers/:id',
    },
    { path: '/:pathMatch(.*)*', redirect: '/trackingHome' },
]
// tslint:disable-next-line:variable-name
let _router: Router;

// If app is embedded in launcher, use launcher router
if (UNIFY_ROUTER) {
    _router = unifiedRouter
}
// If app is standalone, use its own router
else {
    _router = createRouter({
        history: createWebHistory(),
        routes: [],
    });
    _router.addRoute({
        component: Login,
        name: CommonRoutes.LOGIN,
        props: {
            homeRoute: TrackingRoutes.TRACKING_HOME
        },
        path: '/login',
    })
}
// cast: vue-router 4 infers this array as a union of record literals, not RouteRecordRaw[].
routes.forEach(route => _router.addRoute(route as RouteRecordRaw))

export const router = _router;

router.beforeEach((to, __, next) => {
    AuthService.getInstance()
        .waitForUser$()
        .pipe(
            first(),
            map(authenticated => {
                if (!(authenticated && authenticated.user) && to.name !== CommonRoutes.LOGIN) {
                    return { name: CommonRoutes.LOGIN };
                }

                if (authenticated && authenticated.user && to.name === CommonRoutes.LOGIN) {
                    return false;
                }

                return;
            }),
        )
        .subscribe(next);
});
